/* eslint-disable max-len */

import React from 'react';

export const HammerOutlineIcon = () => {
  return (
    <svg
      className="stroke-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.8 4.2C9.8 4.2 10.6667 3.33333 12 3.33333C13.3333 3.33333 14 4 14.6667 4.66667L11.3333 8L9.8 6.46667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.8 4.2L6.46667 7.53333L1.33333 12.6667C1.33333 12.6667 1.33333 14 2 14.6667C2.66667 15.3333 4 14.6667 4 14.6667L9.13333 9.53333L12.4667 6.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33333 10.6667L2 14"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
